import axios from 'axios';

import { Constants } from '@/constants';

export interface CigarBarcode {
  barcode: string;
  productCount: number;
}

export interface CigarBarcodeMutation {
  barcode: string;
  productId: number;
  created: boolean;
}

export const postCigar = async (cigar: any): Promise<any> => {
  try {
    const res = await axios.post(`${Constants.apiPath}/cigars`, cigar);
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const putCigar = async (cigar: any): Promise<any> => {
  try {
    const res = await axios.put(
      `${Constants.apiPath}/cigars/${cigar.id}`,
      cigar
    );
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const updateVitolas = async (
  cigarId: number,
  vitolas: any
): Promise<any> => {
  try {
    const res = await axios.post(
      `${Constants.apiPath}/cigars/${cigarId}/vitolas`,
      vitolas
    );
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const updateVitola = async (vitola: any): Promise<any> => {
  try {
    const res = await axios.put(
      `${Constants.apiPath}/cigars/${vitola.cigar_id}/vitolas/${vitola.id}`,
      vitola
    );
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const getCigarBarcodes = async (
  cigarId: number
): Promise<CigarBarcode[]> => {
  const res = await axios.get(
    `${Constants.apiPath}/cigars/${cigarId}/barcodes`
  );
  return res.data;
};

export const addCigarBarcode = async (
  cigarId: number,
  barcode: string
): Promise<CigarBarcodeMutation> => {
  const res = await axios.post(
    `${Constants.apiPath}/cigars/${cigarId}/barcodes`,
    { barcode }
  );
  return res.data;
};

export const updateCigarBarcode = async (
  cigarId: number,
  oldBarcode: string,
  barcode: string
): Promise<CigarBarcodeMutation> => {
  const res = await axios.put(
    `${Constants.apiPath}/cigars/${cigarId}/barcodes/${encodeURIComponent(
      oldBarcode
    )}`,
    { barcode }
  );
  return res.data;
};

export const getBrands = async (query: string): Promise<string[]> => {
  try {
    const res = await axios.get(`${Constants.apiPath}/brands`, {
      params: { q: query },
    });
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const getManufacturers = async (query: string): Promise<string[]> => {
  try {
    const res = await axios.get(`${Constants.apiPath}/cigars/manufacturers`, {
      params: { q: query },
    });
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const getOrigins = async (query: string): Promise<string[]> => {
  try {
    const res = await axios.get(`${Constants.apiPath}/cigars/origins`, {
      params: { q: query },
    });
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const getWrappers = async (query: string): Promise<string[]> => {
  try {
    const res = await axios.get(`${Constants.apiPath}/cigars/wrappers`, {
      params: { q: query },
    });
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const getBinders = async (query: string): Promise<string[]> => {
  try {
    const res = await axios.get(`${Constants.apiPath}/cigars/binders`, {
      params: { q: query },
    });
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const getFillers = async (query: string): Promise<string[]> => {
  try {
    const res = await axios.get(`${Constants.apiPath}/cigars/fillers`, {
      params: { q: query },
    });
    return res.data;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};
